import React from 'react'

// import MITSUBISHIac from "../images/MITSUBISHI ELECTRIC AC Slider.jpg"

// import ToshibaStablePowerInverter4HP from "../images/RAV-SE561UP_RAV-TE561AP.png";
import cassette2way from "../images/main.jpg";
import StablePowerInverterDuctedAC from "../images/RAV-SE561BP_RAV-TE561AP.png";
import CASSETTE1WAY from "../images/1 WAY CASSETTE photo.jpg";

import MSPCONCEALEDDUCT from "../images/Toshiba MSP CONCEALED DUCT photo.jpg";
import ToshibaIndiaHiWallInverterWallMountedAirConditioner from "../images/G3KCV5SG.png";
import ToshibaSlider from '../inc/ToshibaSlider';
import ToshibaStablePowerPremierInverter2HP from "../images/RAV-SE561UP_RAV-TE561AP.png";
import UnderCeiling from "../images/Under-Ceiling.png";
import ToshibaFLOORSTANDING from "../images/floor-standing.jpg";
import AIRTOAIRHEATEXCHANGERWITHDXCOIL from "../images/Toshiba AIR TO AIR HEAT EXCHANGER WITH COIL.jpg"

function Toshiba() {
  return (
    <div>

 <ToshibaSlider/>
      <br />
      <div className="album py-1 ">

        <div className="container mt-2">
          <center>
            <h3 className='mb-3' style={{ color: "grey" }}><b>Air Conditioning Systems</b></h3>
            <h5>Toshiba India SPI Premier, Best Ceiling Cassette A/C SystemCassette SPI Premier | Cassette SPI Classic</h5>
          </center>
          <br />
        </div>
      </div>

      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={ToshibaStablePowerPremierInverter2HP} className="card-img-top" alt="Toshiba Stable Power Premier Inverter 2HP" />
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1">Toshiba Stable Power Premier Inverter 2HP</h5>
                  <p className="card-text describe mb-2"><small>2 HP 5 STAR</small></p>
                    <div className="d-flex justify-content-between align-items-center">
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>
                  <a href='4way-cassett'>
<button className='waycassett'> 4 WAY CASSETTE</button>
</a>
                  
                  </div>

                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={cassette2way} className="card-img-top" alt="Toshiba 2 WAY CASSETTE"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1">Toshiba 2 WAY CASSETTE</h5>
                  <p className="card-text ptext mb-2"><small>
                  Enhance your aesthetics and cooling comfort with the slim, compact, and lightweight Toshiba 2-Way Cassette air conditioner.</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>
              <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={CASSETTE1WAY} className="card-img-top" alt="Toshiba 1 WAY CASSETTE"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1">Toshiba  1 WAY CASSETTE</h5>
                  <p className="card-text ptext mb-2"><small>Where innovation meets function. The silent and advanced Toshiba 1-Way Cassette is perfected with its slim-line design to fit into compact areas, including hotels, offices, and reception rooms.</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>

               <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={StablePowerInverterDuctedAC} className="card-img-top" alt="StablePowerInverterDuctedAC"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1">Stable Power Inverter Ducted AC </h5>
                  <p className="card-text ptext mb-2"><small>Toshiba India Ducted Stable Power Inverter Range of Air Conditioners</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>
               <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={MSPCONCEALEDDUCT} className="card-img-top" alt="MSPCONCEALEDDUCT"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> MSP CONCEALED DUCT</h5>
                  <p className="card-text mb-2"><small>2 HP 4 STAR</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>


             <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={ToshibaIndiaHiWallInverterWallMountedAirConditioner} className="card-img-top" alt="ToshibaStablePowerInverter3HP"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> Hi Wall Inverter Conditioners</h5>
                  <p className="card-text ptext mb-2"><small>Toshiba India Hi Wall Inverter & Wall Mounted Air Conditioner</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={UnderCeiling} className="card-img-top" alt="UnderCeiling"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> Inverter-console Under Ceiling</h5>
                  <p className="card-text mb-2"><small>Light Weight and Compact Indoor Unit Facilitating Easy Installation </small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>



               <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={ToshibaFLOORSTANDING} className="card-img-top" alt="Toshiba FLOOR STANDING"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> Toshiba FLOOR STANDING</h5>
                  <p className="card-text ptext mb-2"><small>An aesthetic, low-space, silent cooling solution, the Toshiba Floor Standing unit comes in capacities of up to 6 HP.</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>

  <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={AIRTOAIRHEATEXCHANGERWITHDXCOIL} className="card-img-top" alt="AIRTOAIRHEATEXCHANGERWITHDXCOIL"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> AIR TO AIR HEAT EXCHANGER WITH DX COIL</h5>
                  <p className="card-text ptext mb-2"><small>This Toshiba VRF indoor unit is crafted to precondition incoming air, reducing the heating and cooling load and creating a positive pressure to ensure comfortable air supply while protecting against outside grit and dust</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>



          </div>
        </div>
      </div>
      <br />

    </div>
  )
}

export default Toshiba